/**
 * Marks that the checkout the buyer was last sent to payment from was an
 * EXPRESS one (a single digital product), not the stored cart. The payment
 * return page reads it so an express purchase never wipes the stored cart.
 */
export const EXPRESS_CHECKOUT_FLAG = "ld_express_checkout_at";

const MAX_AGE_MS = 2 * 60 * 60 * 1000;

/** True when the last checkout started was express. Consumes the marker. */
export function consumeExpressCheckoutFlag(): boolean {
  try {
    const raw = localStorage.getItem(EXPRESS_CHECKOUT_FLAG);
    localStorage.removeItem(EXPRESS_CHECKOUT_FLAG);
    if (!raw) return false;
    const at = Number(raw);
    return Number.isFinite(at) && Date.now() - at < MAX_AGE_MS;
  } catch {
    return false;
  }
}
